'use client';

import { InverseHeader } from '@jouzen/ecom-components/layout';
import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import MembershipBenefits from './_components/MembershipBenefits/MembershipBenefits';
import MembershipBetterSleep from './_components/MembershipBetterSleep/MembershipBetterSleep';
import MembershipFAQ from './_components/MembershipFAQ/MembershipFAQ';
import MembershipFeatures from './_components/MembershipFeatures/MembershipFeatures';
import MembershipHero from './_components/MembershipHero/MembershipHero';
import MembershipInfoFeatureGrid from './_components/MembershipInfoFeatureGrid/MembershipInfoFeatureGrid';
import MembershipYourHealth from './_components/MembershipYourHealth/MembershipYourHealth';
import { membershipGradients } from './_data/membershipGradients';

const Content = () => {
  return (
    <RadialGradientBG gradients={membershipGradients}>
      <div data-cy="membership-page">
        <MembershipHero />
        <MembershipFeatures />
        <MembershipInfoFeatureGrid />
        <MembershipYourHealth />
        <MembershipBenefits />
        <InverseHeader enter>
          <MembershipFAQ />
          <MembershipBetterSleep />
        </InverseHeader>
      </div>
    </RadialGradientBG>
  );
};

export default Content;
